import classnames from 'classnames'
import { HTMLProps, PropsWithChildren } from 'react'

export function Centered(props: PropsWithChildren<HTMLProps<HTMLDivElement>>) {
  return <div {...props} className={classnames(props.className, 'flex grow items-center justify-center')} />
}
